import { render, staticRenderFns } from "./horizontal-menu-edu.vue?vue&type=template&id=7a3920a8&scoped=true&"
import script from "./horizontal-menu-edu.vue?vue&type=script&lang=js&"
export * from "./horizontal-menu-edu.vue?vue&type=script&lang=js&"
import style0 from "./horizontal-menu-edu.vue?vue&type=style&index=0&id=7a3920a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3920a8",
  null
  
)

export default component.exports